module.exports = __webpack_public_path__ + "img/ling-traditions.697bf772.jpeg";